<template>
    <div>
        <pc-select
            id="selectProgramGroup"
            v-model="selectedGroupId"
            v-bind:label="programGroupSelectorLabel"
            v-bind:options="availableProgramGroups" />
        <pc-select
            id="selectObject"
            v-model="selectedObjectId"
            class="mt-2"
            v-bind:label="objectTypeName"
            v-bind:options="localObjects"
            v-bind:optgroups="objectsByProgram">
            <option value="">
                {{ makeSelectionLabel }}
            </option>
        </pc-select>
        <pc-transition transition="slide">
            <div
                v-if="showDescription"
                class="w-100">
                <span>{{ descriptionLabel }}</span>
                <span style="font-weight: bold">{{ currentDescription }}</span>
            </div>
        </pc-transition>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/linkToSharedObjectModal.i18n.js";
    import { DIALOG_HOOK, DIALOG_RESULT } from "Components/pc-dialog.vue";

    export default {
        props: {
            objectTypeName: { type: String, required: true },
            data: { type: Object, required: true }
        },
        data() {
            return {
                selectedGroupIdInternal: "",
                selectedObjectId: ""
            };
        },
        computed: {
            selectedGroupId: {
                get() {
                    return this.selectedGroupIdInternal;
                },
                set(value) {
                    this.selectedGroupIdInternal = value;
                    this.selectedObjectId = "";
                }
            },
            ...mapI18n(KEYS, NAMESPACE),
            availableProgramGroups() {
                return [
                    { value: "", text: this.noProgramGroupItemLabel },
                    ...this.data.ProgramGroups.map((g) => ({ value: g.PublicId, text: g.Name }))
                ];
            },
            localObjects() {
                let results = [];
                if (!this.selectedGroupId) {
                    results = [...results, ...this.data.LocalObjects.map((g) => ({ value: g.PublicId, text: g.Name }))];
                }
                return results;
            },
            objectsByProgram() {
                const result = [];
                if (!this.selectedGroupId) return result;

                const programGroups = this.sharedObjectsByProgramGroup();

                let index = 0;
                for (const key in programGroups) {
                    const group = programGroups[key];
                    if (group.objects.length > 0) {
                        result[index] = {
                            name: group.name,
                            options: group.objects
                        };
                        index++;
                    }
                }

                return result;
            },
            showDescription() {
                // Share description is only available on objects that are shared to a group
                return this.selectedGroupId && this.selectedObjectId;
            },
            currentDescription() {
                return this.sharedObjectsById()[this.selectedObjectId].Description;
            }
        },
        methods: {
            sharedObjectsByProgramGroup() {
                const programGroups = {};
                for (const program of this.data.Programs) {
                    programGroups[program.PublicId] = {
                        name: program.Name,
                        objects: []
                    };
                }

                for (const object of this.data.SharedObjects) {
                    if (object.ProgramGroups.includes(this.selectedGroupId)) {
                        programGroups[object.Program].objects.push({
                            text: object.Name,
                            value: object.PublicId
                        });
                    }
                }

                return programGroups;
            },
            sharedObjectsById() {
                const objects = {};
                for (const object of this.data.SharedObjects) {
                    objects[object.PublicId] = object;
                }

                return objects;
            },
            [DIALOG_HOOK.isValidToClose](result) {
                // Always ok to cancel
                if (result === DIALOG_RESULT.cancel) {
                    return true;
                }
                return Boolean(this.selectedObjectId);
            },
            [DIALOG_HOOK.getResult]() {
                if (!this.selectedObjectId) {
                    return null;
                }
                if (this.selectedGroupId) {
                    return {
                        programId: this.sharedObjectsById()[this.selectedObjectId].Program,
                        objectId: this.selectedObjectId
                    };
                } else {
                    return {
                        programId: null,
                        objectId: this.selectedObjectId
                    };
                }
            }
        }
    };
</script>
